// Pure, unit-testable helpers for the landing-page search module. No Vue,
// no Firebase — just data transforms.

import { housetype } from '@/app_const.js';

export const NEUTRAL_TYPOLOGY = "Tutte le tipologie";
export const NEUTRAL_CITY = "Tutte le città";

// The hero's first dropdown offers property types (Appartamento, Villa, …),
// sourced from the canonical `housetype` map so the values match what ads store
// in `propertyType`. CompraRedesign reuses PROPERTY_TYPE_OPTIONS for the same
// axis. A leading neutral option keeps "show everything" as the default.
export const PROPERTY_TYPE_OPTIONS = Object.keys(housetype);
export const TYPOLOGY_OPTIONS = [NEUTRAL_TYPOLOGY, ...PROPERTY_TYPE_OPTIONS];

// Build the /annunci query object from the hero selection. Neutral values are
// omitted so the listing page keeps its defaults.
export function buildSearchQuery({ typology, city }) {
  const query = {};
  if (typology && typology !== NEUTRAL_TYPOLOGY) query.tipologia = typology;
  if (city && city !== NEUTRAL_CITY) query.citta = city;
  return query;
}

// Cities with the most listings first (ties alphabetical), each with its
// count — the hero's quick "Esplora" chips. Cards without a city are skipped.
export function topCities(cards, limit = 5) {
  const counts = new Map();
  (cards || []).forEach((c) => {
    if (c && c.city) counts.set(c.city, (counts.get(c.city) || 0) + 1);
  });
  return Array.from(counts, ([city, count]) => ({ city, count }))
    .sort((a, b) => b.count - a.count || a.city.localeCompare(b.city, "it"))
    .slice(0, limit);
}

// Unique, non-empty, alphabetically sorted city names from listing cards.
export function uniqueSortedCities(cards) {
  const set = new Set();
  (cards || []).forEach((c) => {
    if (c && c.city) set.add(c.city);
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b, "it"));
}

// Translate /annunci query params into listing-filter values. Returns null for
// an axis that is absent or (for typology) not in the allowed set.
export function filtersFromQuery(query, allowedTypologies) {
  const q = query || {};
  const city = q.citta ? String(q.citta) : null;
  const typology = q.tipologia && (allowedTypologies || []).includes(String(q.tipologia))
    ? String(q.tipologia)
    : null;
  return { city, typology };
}
